<template>
  <BootstrapDropdown>
    <template #toggle>
      <IconButton
        icon-name="material-symbols:notifications-outline"
        size="lg"
        data-bs-toggle="dropdown"
        data-bs-auto-close="outside"
        :aria-label="translate('Open notifications')"
        :badge="unreadNotifications > 0 ? unreadNotifications.toString() : ''"
      />
    </template>
    <template #items>
      <header
        class="d-flex justify-content-between align-items-center px-3"
        style="width: 26rem; max-width: 100vw"
      >
        <h5 class="mb-0">{{ translate('Notifications') }}</h5>
        <div class="d-flex">
          <BootstrapButton
            v-if="unreadNotifications"
            size="sm"
            name="mark_all_as_read"
            variant="ghost"
            @click="$emit('markAllAsRead')"
          >
            <Icon icon="material-symbols:check" :inline="true" class="me-1" />
            {{ translate('Mark all as read') }}
          </BootstrapButton>
          <IconButton
            icon-name="material-symbols:refresh"
            size="sm"
            :aria-label="translate('Refresh notifications')"
            :loading="loading"
            :disabled="loading"
            @click="$emit('update:page', 0)"
          />
        </div>
      </header>
      <NotificationNav
        :notifications="notifications"
        :tabs="tabs"
        :active-tab="activeTab"
        :count="count"
        :page="page"
        :loading="loading"
        @open-item="(value: Notification) => $emit('openItem', value)"
        @mark-item-as-read="(id: number) => $emit('markItemAsRead', id)"
        @update:active-tab="(value: BootstrapNavItem) => $emit('update:activeTab', value)"
        @update:page="(value: number) => $emit('update:page', value)"
      />
    </template>
  </BootstrapDropdown>
</template>
<script lang="ts" setup>
import {type BootstrapNavItem} from '@/components/shared/bootstrap/BootstrapNav/BootstrapNav.types';
import {Notification} from '@/stores/apolloPlatform/notifications/notifications';
defineProps<{
  notifications: Notification[];
  unreadNotifications: number;
  tabs: BootstrapNavItem[];
  activeTab: BootstrapNavItem;
  count: number;
  page: number;
  loading: boolean;
}>();
defineEmits<{
  markAllAsRead: [];
  markItemAsRead: [id: number];
  openItem: [value: Notification];
  'update:activeTab': [value: BootstrapNavItem];
  'update:page': [value: number];
}>();
const {translate} = useLocalisation();
</script>
